import "./style.scss";
import * as React from "react";
import { Input as AntDInput } from "antd";

class Input extends React.Component<IInput, any> {
  render() {
    const {
      type,
      label,
      name,
      className,
      handleChange,
      value,
      placeholder,
      disabled
    } = this.props;

    return (
      <div className="label-input {className}">
        <label>{label}</label>
        <AntDInput
          type={type}
          onChange={handleChange}
          placeholder={placeholder}
          value={value}
          name={name}
          disabled={disabled}
        />
      </div>
    );
  }
}

interface IInput {
  type?: "password" | "text" | "textarea";
  label?: string;
  name?: string;
  className?: string;
  placeholder?: string;
  value?: string;
  handleChange?: (e: any) => void;
  disabled?: boolean;
}

export default Input;



// WEBPACK FOOTER //
// ./client/modules/form/Input/index.tsx